import { Icon } from '@euler/components/Icomoon';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import Animated from 'react-native-reanimated';

export const Caret = memo(
  ({
    style,
    color,
    size = 32,
  }: {
    style?: StyleProp<ViewStyle>;
    color?: string;
    size?: number;
  }) => {
    return (
      <Animated.View style={style}>
        <Icon name="keyboard_arrow_up" size={size} color={color ?? '#000'} />
      </Animated.View>
    );
  },
);
